'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.SideNav = SideNav;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _styles = require('@material-ui/core/styles');

var _colors = require('@material-ui/core/colors');

var _List = require('@material-ui/core/List');

var _List2 = _interopRequireDefault(_List);

var _Drawer = require('@material-ui/core/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _Footer = require('./Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _Header = require('./Header');

var _Header2 = _interopRequireDefault(_Header);

var _Link = require('./Link');

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isHeader = function isHeader(child) {
  return child && child.type && child.type === _Header2.default;
};

var isFooter = function isFooter(child) {
  return child && child.type && child.type === _Footer2.default;
};

function SideNav(props) {
  var children = props.children,
      className = props.className,
      classes = props.classes,
      isOpen = props.isOpen,
      onClose = props.onClose,
      variant = props.variant;


  var childrenArray = React.Children.toArray(children);
  var footer = childrenArray.length > 0 ? childrenArray.filter(isFooter) : null;
  var header = childrenArray.length > 0 ? childrenArray.filter(isHeader) : null;
  var listItems = childrenArray.filter(function (child) {
    if (child.type && (isHeader(child) || isFooter(child))) {
      return false;
    }
    return true;
  }).map(function (_child, key) {
    var child = _child;

    if (child.type === _Link2.default) {
      var childClasses = child.props.classes || {};

      child = React.cloneElement(child, {
        activeClassName: child.props.activeClassName || classes.activeLink,
        classes: (0, _extends3.default)({
          root: childClasses.root || classes.linkRoot
        }, childClasses),
        onClose: onClose
      });
    }

    return React.createElement(
      'li',
      { key: key },
      child
    );
  });

  return React.createElement(
    _Drawer2.default,
    {
      open: isOpen,
      onClose: function (_onClose) {
        function onClose() {
          return _onClose.apply(this, arguments);
        }

        onClose.toString = function () {
          return _onClose.toString();
        };

        return onClose;
      }(function () {
        return onClose();
      }),
      classes: {
        paper: (0, _classnames3.default)(classes.paper, (0, _defineProperty3.default)({}, classes.paper__isFixed, variant === 'temporary'), className)
      },
      variant: variant
    },
    header ? header[0] : null,
    listItems.length > 0 ? React.createElement(
      _List2.default,
      {
        'aria-label': 'navigation',
        disablePadding: true,
        role: 'navigation',
        classes: {
          root: classes.list
        }
      },
      listItems
    ) : null,
    footer ? footer[0] : null
  );
}

SideNav.defaultProps = {
  classes: {},
  variant: 'temporary'
};

var styles = function styles(theme) {
  return {
    activeLink: {
      backgroundColor: _colors.grey[400]
    },
    linkRoot: {
      color: _colors.grey[900],
      '&:focus, &:hover': {
        backgroundColor: theme.palette.action.hover,
        outline: 'none'
      }
    },
    paper: {
      width: 250,
      position: 'static'
    },
    paper__isFixed: {
      position: 'fixed'
    },
    list: {
      overflow: 'visible',
      flex: '1 1 auto'
    }
  };
};

exports.default = (0, _styles.withStyles)(styles)(SideNav);